var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 52 52"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 21,
    fill: "none",
    stroke: "currentColor",
    strokeDasharray: "98.96016858807849 34.98672286269283",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 26 26;360 26 26"
  }))));
};
export default SvgLoader;